export enum RoleType {
  Role = "ROLE",
  Person = "PERSON",
}
